<template>
    <div id="fb-post">
        <div class="headline ma-3 text-color bold">
            BUFF LIKE, COMMENT, SHARE POST
        </div>
        <div class="container-tabs" v-if="maintain">
            <h1 class="maintain_notice">Job này đang bảo trì</h1>
        </div>
        <div class="container-tabs" v-else>
            <v-tabs :background-color="COLOR.BG_MAIN_COLOR">
                <v-tab href="#create-process" active-class="text-color">Tạo tiến trình</v-tab>
                <!-- <v-tab href="#create-process-bonus"  active-class="text-color">Tạo tiến trình với điểm thưởng</v-tab> -->
                <v-tab href="#activity-log"  active-class="text-color">Nhật ký Order</v-tab>
                <v-tab-item value="create-process">
                    <FbPostCreateProcess />
                </v-tab-item>
                <!-- <v-tab-item value="create-process-bonus">
                    <FbPostCreateProcessBonus />
                </v-tab-item> -->
                <v-tab-item value="activity-log">
                    <FbPostActivityLog />
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import FbPostCreateProcess from "~/components/fb-post/FbPostCreateProcess";
// import FbPostCreateProcessBonus from "~/components/fb-post/FbPostCreateProcessBonus";
import FbPostActivityLog from "~/components/fb-post/FbPostActivityLog";
import { COLOR, SEEDING_TYPE } from "~/config/constant";
import { SEEDING_TYPE_MAINTAIN } from "~/store/actions.type";

export default {
    components: {
        FbPostCreateProcess,
        FbPostActivityLog,
        // FbPostCreateProcessBonus
    },
    data() {
        return {
            COLOR: COLOR,
            maintain: false
        }
    },
    methods: {
        async getDataFromApi () {
            let dataInfo = await this.$store.dispatch(SEEDING_TYPE_MAINTAIN);
            if (dataInfo.includes(SEEDING_TYPE.ID_FACEBOOK_SHARE_POST)
                && dataInfo.includes(SEEDING_TYPE.ID_FACEBOOK_REACTION_POST)
                && dataInfo.includes(SEEDING_TYPE.ID_FACEBOOK_COMMENT_POST)) {
                this.maintain = true;
            }
        },
    },
    mounted() {
        this.getDataFromApi();
    },
};
</script>
<style lang="scss">
    @import "../../scss/main";
    #fb-post {
        .v-tabs-slider-wrapper {
            color: $mainColor !important;
        }
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
    }
</style>
